export default "__VITE_ASSET__BB$Qfijt__"